export function escapeHTML (text) {
  const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }
  return String(text ?? '').replace(/[&<>"']/g, character => entities[character])
}

// Same-site paths, Vinterior's own sites (the Support Centre, policy pages) and its email addresses.
export function safeHref (href) {
  if (/^\/[^/\\]/.test(href)) return href
  if (/^https:\/\/([a-z0-9-]+\.)*vinterior\.co(\/[^\\]*)?$/i.test(href)) return href
  if (/^mailto:[a-z0-9._%+-]+@vinterior\.co$/i.test(href)) return href
  return null
}

// Escape first: only structure (p, br, ul, ol, li), <a> (Vinterior links only) and <strong> reach the DOM.
// Links open in a new tab, so the chat stays where it is.
export function renderRichText (text) {
  return escapeHTML(text)
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (match, label, href) => {
      const target = safeHref(href)
      return target ? `<a class="vsd-vera__link" href="${target}" target="_blank" rel="noopener">${label}</a>` : label
    })
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
}

export function blocksToHTML (blocks = []) {
  return blocks
    .filter(block => block.type === 'text')
    .map(block => textToHTML(block.text))
    .join('')
}

function textToHTML (text) {
  return paragraphs(text).flatMap(runs).map(runHTML).join('')
}

function paragraphs (text) {
  return String(text ?? '')
    .split(/\n\s*\n/)
    .map(paragraph => paragraph.split('\n').filter(line => line.trim() !== ''))
    .filter(lines => lines.length)
}

// Consecutive lines of the same kind (bullets, numbers, prose) render as one block.
function runs (lines) {
  return lines.reduce((groups, line) => {
    const tag = listTag(line)
    const last = groups[groups.length - 1]
    if (last?.tag === tag) last.lines.push(line)
    else groups.push({ tag, lines: [line] })
    return groups
  }, [])
}

function listTag (line) {
  if (/^\s*[-*•]\s+/.test(line)) return 'ul'
  if (/^\s*\d+[.)]\s+/.test(line)) return 'ol'
  return null
}

function runHTML ({ tag, lines }) {
  if (!tag) return `<p>${lines.map(renderRichText).join('<br>')}</p>`

  const items = lines.map(line => `<li>${renderRichText(line.replace(/^\s*([-*•]|\d+[.)])\s+/, ''))}</li>`)
  return `<${tag}>${items.join('')}</${tag}>`
}
